import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { DataTable } from '../../../components'
import { useMessage, useModalDialog } from '../../../hooks'
import { useClientCaseDialog } from '../hooks'
import { clientService } from '../services'
import { appName } from '../appConfig'
import '../index.css'

const STATUS_VALUES = {
  active:   { label: 'Aktiv',   className: 'pill pill-green' },
  inactive: { label: 'Inaktiv', className: 'pill pill-grey' },
}

const flatten = (c) => ({
  ...c,
  updated: c.modified_timestamp || c.created_timestamp,
  // formatData's null-guard checks item[column.id], not item[column.data.data] —
  // the Utvärderingar button needs its own truthy field distinct from the Visa
  // column's client_slug (same id would collide as a React key in the header).
  client_slug_reviews: c.client_slug,
})

const ClientList = () => {
  const navigate = useNavigate()
  const { showMessage } = useMessage()
  const { hideModalDialog } = useModalDialog()
  const { showClientDialog, showDeleteClientDialog } = useClientCaseDialog()

  const [clients, setClients] = useState([])
  const [selectedItems, setSelectedItems] = useState([])
  const [loading, setLoading] = useState(true)

  const fetchClients = () => {
    setLoading(true)
    clientService.getAll()
      .then(res => { setClients((res.clients || []).map(flatten)); setLoading(false) })
      .catch(() => { showMessage('Kunde inte ladda kunder', 'error'); setLoading(false) })
  }

  const createClient = () => {
    showClientDialog(null, (client) => { showMessage('Skapad!'); navigate(`/${appName}/${client.client_slug}`) })
  }

  const editClient = (items) => {
    showClientDialog(items[0], () => { showMessage('Sparad!'); fetchClients() })
  }

  useEffect(() => {
    fetchClients()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const deleteClient = (items) => {
    const c = items[0]
    showDeleteClientDialog(c, async () => {
      await clientService.remove(c.client_uuid)
        .then(() => { hideModalDialog(); showMessage('Borttagen'); setSelectedItems([]); fetchClients() })
        .catch(err => showMessage(err.message || 'Kunde inte ta bort', 'error'))
    })
  }

  return (
    <div className="ClientList wide-margin">
      <DataTable
        data={clients}
        idColumn="client_uuid"
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        loading={loading}
        filterable
        filterObjects={['company_name', 'company_industry', 'client_slug']}
        columns={[
          { id: 'client_slug', name: 'Visa', type: 'button', label: 'Visa', data: { data: 'client_slug' },
            onClick: (slug) => navigate(`/${appName}/${slug}`) },
          { id: 'company_name',    name: 'Kund',                className: 'bold' },
          { id: 'company_industry', name: 'Bransch' },
          { id: 'client_status',   name: 'Status', type: 'pill', value: 'client_status', values: STATUS_VALUES },
          { id: 'case_count',      name: 'Antal case' },
          { id: 'review_count',    name: 'Antal utvärderingar' },
          { id: 'client_slug_reviews', name: 'Utvärderingar', type: 'button', label: 'Utvärderingar', data: { data: 'client_slug' },
            onClick: (slug) => slug && navigate(`/${appName}/${slug}/reviews`) },
          { id: 'updated',         name: 'Uppdaterad', type: 'datetime' },
        ]}
        buttons={[
          { label: '+ Ny kund', action: 'add', mainButton: true, onClick: createClient },
          { label: 'Redigera', action: 'edit', onClick: editClient },
          { label: 'Ta bort', action: 'delete', onClick: deleteClient },
        ]}
      />
    </div>
  )
}

export default ClientList
